















































































import Component from 'vue-class-component';
import ChargingOption from './charging-option.vue';
import SubHeadline from '../sub-headline/sub-headline.vue';
import ChargingOptionsGridFunctions from './charging-options-grid-functions.vue';
import { BatteryChangingInformationSeparated } from '../../store/modules/charging-data.interface';

@Component({
  name: 'eqweb-charging-options-grid',
  components: { ChargingOption, SubHeadline },
})
export default class ChargingOptionsGrid extends ChargingOptionsGridFunctions {
  protected getMq3Cols(chargingOptions: BatteryChangingInformationSeparated): number {
    if (
      this.getChargingOptions(chargingOptions.home).length === 0 ||
      this.getChargingOptions(chargingOptions.public).length === 0
    ) {
      return 2;
    }

    return 4;
  }
}
